import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-bars sidebar-button",
  "data-bs-toggle": "offcanvas",
  href: "#offcanvasExample",
  role: "button",
  "aria-controls": "offcanvasExample"
}, null, -1)
const _hoisted_2 = {
  class: "offcanvas offcanvas-start sidebar",
  tabindex: "-1",
  id: "offcanvasExample",
  "aria-labelledby": "offcanvasExampleLabel"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn-close btn-close-white sidebar-close",
  "data-bs-dismiss": "offcanvas"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "offcanvas-header sidebar-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    id: "offcanvasExampleLabel",
    class: "text-center"
  }, " Memphis Lions Club ")
], -1)
const _hoisted_5 = { class: "offcanvas-body sidebar-body" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "sidebar-links" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-palette me-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Mint and View your NFTs ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-home me-2" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Visit the Clubhouse ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-handshake me-2" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Checkout our Partners ")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-store me-2" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Buy Merchanise ")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-question me-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" More Info ")
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

import PageFooter from '@/components/PageFooter.vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarNav',
  setup(__props) {

const router = useRouter();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          class: "sidebar-logo",
          src: require('@/assets/mlc-logo-fill.png'),
          alt: "MLC"
        }, null, 8, _hoisted_6),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            "data-bs-dismiss": "offcanvas",
            class: "sidebar-link btn btn-link text-decoration-none",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('gallery')))
          }, _hoisted_10),
          _createElementVNode("button", {
            "data-bs-dismiss": "offcanvas",
            class: "sidebar-link btn btn-link text-decoration-none",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('clubhouse')))
          }, _hoisted_13),
          _createElementVNode("button", {
            "data-bs-dismiss": "offcanvas",
            class: "sidebar-link btn btn-link text-decoration-none",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('partnership-pavilion')))
          }, _hoisted_16),
          _createElementVNode("button", {
            "data-bs-dismiss": "offcanvas",
            class: "sidebar-link btn btn-link text-decoration-none",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('shop')))
          }, _hoisted_19),
          _createElementVNode("button", {
            "data-bs-dismiss": "offcanvas",
            class: "sidebar-link btn btn-link text-decoration-none",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('info')))
          }, _hoisted_22),
          _createVNode(PageFooter)
        ])
      ])
    ])
  ]))
}
}

})